import  InputSelect  from './input-select.component'

export default InputSelect
